import React from 'react';
import { Icon } from '@ok/okd';

import './index.less';

export default function ({
  showPassword,
  onToggleShowPassword,
  className = '',
}) {
  const boxClassName = `toggle-password-box ${className}`.trim();
  const iconName = showPassword
    ? 'okds-eye-show-filled'
    : 'okds-eye-hide-filled';
  return (
    <div className={boxClassName} onClick={onToggleShowPassword}>
      <Icon className={iconName} />
    </div>
  );
}
